import { render, staticRenderFns } from "./SortableHandle.vue?vue&type=template&id=36e74920&scoped=true&"
import script from "./SortableHandle.vue?vue&type=script&lang=ts&"
export * from "./SortableHandle.vue?vue&type=script&lang=ts&"
import style0 from "./SortableHandle.vue?vue&type=style&index=0&id=36e74920&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e74920",
  null
  
)

export default component.exports